var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-icon-small-container"},[_c('div',{staticClass:"loading-icon circle",style:(_vm.overrideStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }